module.exports = __webpack_public_path__ + "img/tutorial-f05-04.5318ae01.png";